"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("react"),
    e = require("@react-pdf-viewer/core");

function r(t) {
  if (t && t.__esModule) return t;
  var e = Object.create(null);
  return t && Object.keys(t).forEach(function (r) {
    if ("default" !== r) {
      var n = Object.getOwnPropertyDescriptor(t, r);
      Object.defineProperty(e, r, n.get ? n : {
        enumerable: !0,
        get: function get() {
          return t[r];
        }
      });
    }
  }), e.default = t, Object.freeze(e);
}

var n,
    o = r(t);
exports.RotateDirection = void 0, (n = exports.RotateDirection || (exports.RotateDirection = {})).Backward = "Backward", n.Forward = "Forward";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _c = function c() {
  return (_c = Object.assign || function (t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      for (var o in e = arguments[r]) {
        Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    a = function a() {
  return o.createElement(e.Icon, {
    size: 16
  }, o.createElement("path", {
    d: "M3.434,10.537c0.141-0.438,0.316-0.864,0.523-1.274\n            M3.069,14.425C3.023,14.053,3,13.679,3,13.305 c0-0.291,0.014-0.579,0.041-0.863\n            M4.389,18.111c-0.341-0.539-0.623-1.112-0.843-1.711\n            M7.163,20.9 c-0.543-0.345-1.048-0.747-1.506-1.2\n            M10.98,22.248c-0.65-0.074-1.29-0.218-1.909-0.431\n            M10,4.25h2 c4.987,0.015,9.017,4.069,9.003,9.055c-0.013,4.581-3.456,8.426-8.008,8.945\n            M13.5,1.75L10,4.25l3.5,2.5"
  }));
},
    i = function i() {
  return o.createElement(e.Icon, {
    size: 16
  }, o.createElement("path", {
    d: "M20.566,10.537c-0.141-0.438-0.316-0.864-0.523-1.274\n            M20.931,14.425C20.977,14.053,21,13.679,21,13.305 c0-0.291-0.014-0.579-0.041-0.863\n            M19.611,18.111c0.341-0.539,0.624-1.114,0.843-1.713\n            M16.837,20.9 c0.543-0.345,1.048-0.747,1.506-1.2\n            M13.02,22.248c0.65-0.074,1.29-0.218,1.909-0.431\n            M14,4.25h-2 c-4.987,0.015-9.017,4.069-9.003,9.055c0.013,4.581,3.456,8.426,8.008,8.945\n            M10.5,1.75l3.5,2.5l-3.5,2.5"
  }));
},
    u = {
  left: 0,
  top: 8
},
    l = function l(t) {
  var r = t.direction,
      n = t.onClick,
      c = o.useContext(e.LocalizationContext),
      l = c && c.rotate ? c.rotate.rotateBackward : "Rotate counterclockwise",
      f = c && c.rotate ? c.rotate.rotateForward : "Rotate clockwise",
      d = r === exports.RotateDirection.Backward ? l : f,
      s = r === exports.RotateDirection.Backward ? o.createElement(a, null) : o.createElement(i, null);
  return o.createElement(e.Tooltip, {
    ariaControlsSuffix: "rotate",
    position: e.Position.BottomCenter,
    target: o.createElement(e.MinimalButton, {
      ariaLabel: d,
      onClick: n
    }, s),
    content: function content() {
      return d;
    },
    offset: u
  });
},
    f = function f(t) {
  var e = t.children,
      r = t.direction,
      n = t.store,
      c = function (t) {
    var e = o.useState(t.get("rotation") || 0),
        r = e[0],
        n = e[1],
        c = function c(t) {
      n(t);
    };

    return o.useEffect(function () {
      return t.subscribe("rotation", c), function () {
        t.unsubscribe("rotation", c);
      };
    }, []), {
      rotation: r
    };
  }(n).rotation;

  return (e || function (t) {
    return o.createElement(l, {
      direction: t.direction,
      onClick: t.onClick
    });
  })({
    direction: r,
    onClick: function onClick() {
      var t = n.get("rotate");

      if (t) {
        var e = r === exports.RotateDirection.Backward ? -90 : 90;
        t(360 === c || -360 === c ? e : c + e);
      }
    }
  });
},
    d = function d(t) {
  var r = t.direction,
      n = t.onClick,
      c = o.useContext(e.LocalizationContext),
      u = c && c.rotate ? c.rotate.rotateBackward : "Rotate counterclockwise",
      l = c && c.rotate ? c.rotate.rotateForward : "Rotate clockwise",
      f = r === exports.RotateDirection.Backward ? u : l,
      d = r === exports.RotateDirection.Backward ? o.createElement(a, null) : o.createElement(i, null);
  return o.createElement(e.MenuItem, {
    icon: d,
    onClick: n
  }, f);
};

exports.RotateBackwardIcon = a, exports.RotateForwardIcon = i, exports.rotatePlugin = function () {
  var t = o.useMemo(function () {
    return e.createStore({
      rotation: 0
    });
  }, []),
      r = function r(e) {
    return o.createElement(f, _c({}, e, {
      store: t
    }));
  };

  return {
    install: function install(e) {
      t.update("rotate", e.rotate);
    },
    onViewerStateChange: function onViewerStateChange(e) {
      return t.update("rotation", e.rotation), e;
    },
    Rotate: r,
    RotateBackwardButton: function RotateBackwardButton() {
      return o.createElement(r, {
        direction: exports.RotateDirection.Backward
      }, function (t) {
        return o.createElement(l, _c({}, t));
      });
    },
    RotateBackwardMenuItem: function RotateBackwardMenuItem(t) {
      return o.createElement(r, {
        direction: exports.RotateDirection.Backward
      }, function (e) {
        return o.createElement(d, {
          direction: e.direction,
          onClick: function onClick() {
            e.onClick(), t.onClick();
          }
        });
      });
    },
    RotateForwardButton: function RotateForwardButton() {
      return o.createElement(r, {
        direction: exports.RotateDirection.Forward
      }, function (t) {
        return o.createElement(l, _c({}, t));
      });
    },
    RotateForwardMenuItem: function RotateForwardMenuItem(t) {
      return o.createElement(r, {
        direction: exports.RotateDirection.Forward
      }, function (e) {
        return o.createElement(d, {
          direction: e.direction,
          onClick: function onClick() {
            e.onClick(), t.onClick();
          }
        });
      });
    }
  };
};